import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { glyphs, useMediaQuery } from "../../../Styles";
import { Button, ProgressSteps, QuickEntryModalLvl1, QuickEntryModalLvl2, QuickEntryModalLvl3, NewModal, MainContentPaddingTypes, ButtonList } from "../..";
import { QuickEntry, quickEntryChange } from "../../../Definitions";
import { PanelMaintainAnimal } from "../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/maintainAnimalInfoCall";
import { useAppSelector } from "../../../Store";
import { Graph_QL } from "../../../Services";
import { useAnimal } from "../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimal";

interface ReportModal_Props {
  isModalOpen: boolean
  closeModal: () => void,
}

export default function ReportModal({isModalOpen, closeModal}:ReportModal_Props) {
  const {t} = useTranslation()
  const [currentQuickEntryLevel, setCurrentQuickEntryLevel] = useState(1);
  const mobileXs = useMediaQuery(`(max-width: 793px)`);
  const [quickEntryData, setQuickEntryData] = useState<QuickEntry[]>([]);
  const [quickEntryChange, setQuickEntryChange] = useState<quickEntryChange[]>([]);
  const dirtRef = useRef<PanelMaintainAnimal[]>([]);

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);
  const { data: animalsState, maintainEntries: updateAnimals } = useAnimal(connection);

  // Function to handle Quick Entry Modal based on level
  const ShowQuickEntry = (level: 0 | 1 | 2 | 3) => {
    setCurrentQuickEntryLevel(level);
  };

  // Reset state when modal opens
  useEffect(() => {
    if (isModalOpen) {
      setCurrentQuickEntryLevel(1); // Reset to Main Info Modal
    }
  }, [isModalOpen]);

  // Function to handle "Go Back"
  const onGoBack = () => {
    if (currentQuickEntryLevel === 3) {
      ShowQuickEntry(2); // Go back to Level 2
    } else if (currentQuickEntryLevel === 2) {
      ShowQuickEntry(1); // Go back to Level 1
    } 
  }
    
  return (
    <NewModal
      modalState={isModalOpen}
      overrides={{
        mainContentPadding: (currentQuickEntryLevel === 3) ? undefined : MainContentPaddingTypes.secondary,
        headerContentHeight: "65px"
      }}
      predefinedButtons={{
        onClose: closeModal,
        onGoBack: currentQuickEntryLevel === 2 || currentQuickEntryLevel === 3? onGoBack : undefined
      }}
      header={t("animalPages.animals.quickEntry", {defaultValue: "quick entry"})}
      headerContent={
        <ProgressSteps 
          titles={[t("animalPages.animals.selectAnimals", {defaultValue: "select animals"}), t("animalPages.animals.action", {defaultValue: "action"}), t("animalPages.animals.viewChanges", {defaultValue: "view changes"})]} 
          icons={[glyphs.Animal({}), glyphs.Animal({}), glyphs.Animal({})]} opacityValues={currentQuickEntryLevel === 1 ? [1, 0.5, 0.5] : currentQuickEntryLevel === 2 ? [0.5, 1, 0.5] : [0.5, 0.5, 1] }
        />
      }
      secondaryContent={ currentQuickEntryLevel === 3 ? undefined :
        <div style={{width: mobileXs ? "290px" : "605px" }}>
          {currentQuickEntryLevel === 1 && <QuickEntryModalLvl1 quickEntryData={quickEntryData} onQuickEntryDataChange={setQuickEntryData}/>} {/* Select Modal */}
          {currentQuickEntryLevel === 2 && <QuickEntryModalLvl2 quickEntryChange={quickEntryChange} onQuickEntryChange={setQuickEntryChange}/>} {/* Action Modal */}
          
        </div>
      }
      mainContent={
        <>
          {(currentQuickEntryLevel === 3) ? <QuickEntryModalLvl3 quickEntryData={quickEntryData} quickEntryChange={quickEntryChange} dirtyDataRef={dirtRef} /> : 
          <div style={{ width: "100%", display: "flex", justifyContent: "center", paddingBottom: currentQuickEntryLevel === 3 ? "50px" : "0px"}}>
          <ButtonList
            contents={(currentQuickEntryLevel === 1) ? [t("buttons.next", {defaultValue: "next"})] : ["View changes", "Apply changes"]}
            onClick={(i) => {
              if (i === 0) { (currentQuickEntryLevel === 1) ? setCurrentQuickEntryLevel(2) : setCurrentQuickEntryLevel(3) }
              if (i === 1) { closeModal(); if (updateAnimals) { updateAnimals({ data: dirtRef.current }); dirtRef.current = [] }} 
            }}
            overrides={{
             baseButton: {width: currentQuickEntryLevel === 2 ? "fit-content" : "280px"}   
            }}
          />
        </div>
          }
            
        </>
      }
    />
  );
}